import { faMinus, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import "./IncrementDecrementBtnCart.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCart,
  postCartQuantity,
} from "../../../../features/cart/cartSlice";

const IncrementDecrementBtnCart = ({ quantity, setQuantity, val }) => {
  // const [quantity, setQuantity] = useState(1);
  const dispatch = useDispatch();

  const isSignIn = useSelector((state) => state.auth.is_signin);

  const increment = () => {
    setQuantity((prev) => prev + 1);
  };

  const decrement = () => {
    setQuantity((prev) => (prev > 1 ? prev - 1 : 1));
  };
  const [error, setError] = useState("");

  const cartQuantity = async (type) => {
    try {
      const stock =
        val?.Triple_Variant?.stock ??
        val?.Double_Variant?.stock ??
        val?.Product_Variant?.general_stock ??
        0;

      if (type === "add" && Number(quantity) >= Number(stock)) {
        setError(`Only ${stock} quantity in stock`);
        return;
      }

      setError("");
      const data = {
        cart_id: val?.id,
        type: type,
        isSignIn,
        product_id: val.product_id,
        variant_id: val.variant_id,
        d_variant_id: val.d_variant_id,
        t_variant_id: val.t_variant_id,
        variant_type_id: val.Product.variant_type_id,
      };
      const res = await dispatch(postCartQuantity(data));
      if (res.meta?.requestStatus === "fulfilled") {
        dispatch(getAllCart(isSignIn));
      } else if (res.meta?.requestStatus === "rejected") {
        // console.log("Error:", res.payload || "Not In Cart");
      }
    } catch (error) {
      // console.log("Error:", error);
    }
  };

  console.log(error, "Errors Errors");

  return (
    <div className="Increment_Decrement_Btn">
      <div className={`main_content_holder`}>
        {/* Decrement Button */}
        <div
          className="icon_holder"
          onClick={() => {
            cartQuantity("minus");
          }}
        >
          <FontAwesomeIcon icon={faMinus} className="icon_class" />
        </div>

        <div className="count_holder">
          <p className="count">{quantity}</p>
        </div>

        {/* {Number(val?.Product_Variant?.general_stock) >= Number(quantity) ||
        Number(val?.Double_Variant?.stock) >= Number(quantity) ||
        Number(val?.Triple_Variant?.stock) >= Number(quantity) ? ( */}
        <div
          className="icon_holder"
          onClick={() => {
            cartQuantity("add");
          }}
        >
          <FontAwesomeIcon icon={faPlus} className="icon_class" />
        </div>
        {/* ) : (
          <p className="text-danger fw-bold">Out of stock</p>
        )} */}
      </div>

      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
};

export default IncrementDecrementBtnCart;
